<!--
 * @Description: 我的运单
 * @Author: ganjia
 * @Date: 2019-10-11 10:09:33
 -->
<template>
  <div class="main-wrap order">
    <div class="order-top">
      <div class="search-btns">
        <el-form :inline="true">
          <!--<el-form-item v-if="exportStatus === 'wait_print'">
            <el-button
              type="primary"
              :loading="mergeLoading"
              :disabled="multipleSelection.length > 1 && (exportStatus === 'all' || exportStatus === 'wait_print') ? false : true"
              @click="mergeOrder"
              class="h40"
              icon="iconfont iconhedan"
              >{{ $lang('合单') }}</el-button
            >
          </el-form-item>-->
          <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
            <print
              ref="printOrder"
              :typeName="'oneAndtwoLinkPage'"
              :getPrintData="getPrintData"
              :options="printOptions"
              :hasPower="true"
              @printbtn="printClick()"
              :isDisabled="multipleSelection.length > 0 ? false : true"
            ></print>
          </el-form-item>
          <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
            <el-button type="primary" class="h40" @click="batchCancelOrder" :disabled="multipleSelection.length > 0 ? false : true" icon="iconfont iconshanchu">{{
              $lang('批量取消')
            }}</el-button>
          </el-form-item>
          <el-form-item v-if="exportStatus === 'already_cancle'">
            <el-button type="primary" class="h40" @click="batchDelOrder" :disabled="multipleSelection.length > 0 ? false : true" icon="iconfont iconshanchu">{{
              $lang('批量删除')
            }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icondaochu" type="primary" @click="exportOpen" :loading="exportLoading" class="h40" plain>{{ $lang('导出') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="order-topLeft" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始时间')"
              :end-placeholder="$lang('结束时间')"
              class="commonSize"
              @change="selectDate"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="ids">
            <!-- <el-input v-model="searchParam.ids[0]" placeholder="请输入订单编号"></el-input> -->
            <base-input-tag-new
              style="width:220px"
              v-model="searchParam.ids"
              :placeholder="$lang('请输入订单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
               ref="BaseInputTag1"
              class="cms-input-tag">
            </base-input-tag-new>
          </el-form-item>
          <el-form-item prop="waybillIds">
            <!-- <el-input v-model="searchParam.waybillIds[0]" placeholder="请输入运单编号"></el-input> -->
            <base-input-tag-new
              style="width:210px"
              v-model="searchParam.waybillIds"
              :placeholder="$lang('请输入运单编号(最多可查100条)')"
              :clearBtnVisible="true"
              ref="BaseInputTag2"
              :addTagOnBlur="true"
              class="cms-input-tag">
            </base-input-tag-new>
          </el-form-item>
          <el-form-item prop="receiverMobilePhone">
            <el-input v-model="searchParam.receiverMobilePhone" :placeholder="$lang('请输入收件人联系电话')" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item prop="customerOrderId">
            <el-input v-model="searchParam.customerOrderIds[0]" :placeholder="$lang('客户订单号')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32">{{ $lang('查询') }} </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="resetSearch" icon="iconfont iconshanchu" class="h32">{{ $lang('清空') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="order-bottom">
      <div class="tabs-nav">
        <div class="tabs-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index)" :class="{ active: tabActive === index }">
          {{ item.orderStatusName }}<span class="tabs-nav-item-count">{{ item.total }}</span>
        </div>
      </div>
      <JmsTableScroll
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @size-change="sizeChange"
        :isCheckedAll="isCheckedAll"
        @select-all="handleSelectAll1"
        @select="handleSelectionChange"
        @current-change="currentChange"
      >
        <template slot="orderStatusName" slot-scope="{ row }">
          <span class="dot" :class="orderStatusClass(row.orderStatusName)">{{ row.orderStatusName }}</span>
        </template>
        <template slot="waybillId" slot-scope="data">
          <el-tooltip placement="top">
            <div slot="content" @click="handleCopy(data)" style="cursor:pointer">{{ $lang('复制运单号') }}</div>
            <span @click="getExpressTracking(data.row.waybillId)" class="getExpressTracking">{{ data.row.waybillId }}</span>
          </el-tooltip>
        </template>
        <template slot="menu" slot-scope="{row}">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(row)" type="text">{{ $lang('查看') }}</el-button>
            <!-- 编辑按钮 -->
             <el-button v-if="$hasPower('orderEdit', row)" v-show="[100,101,102,106,105].includes(row.orderStatusCode)" @click="rowEdit(row)" type="text" >{{ $lang('编辑') }}</el-button>
            <!-- 取消按钮 -->
            <el-button v-if="$hasPower('orderCancel', row)" v-show="orderStatusClass(row.orderStatusName) === 'oragin'" @click="cancelFn(row)" type="text">{{ $lang('取消') }}</el-button>
            <!-- 删除按钮 -->
            <!-- <el-button v-show="data.row.orderStatusName=='已取消'" @click="rowDel({'orderId':data.row.id})" type="text">{{ $lang('删除') }}</el-button> -->
          </div>
        </template>
      </JmsTableScroll>
    </div>

    <!-- 编辑订单弹框组件 -->
    <merge-order ref="mergeOrder" :mergeVisible="isShowMerge" :mergeList="mergeList" @closeMerge="closeMerge"></merge-order>
    <!-- 订单详情弹框组件 -->
    <bullet ref="bullet" :viewDialogVisible="viewDialogVisible" @closeDetails="closeDetails" :bulletTitle="1" :rowData="rowData"></bullet>
    <!-- 取消订单弹框组件 -->
    <cancel-order :selectId="selectId" ref="cancelOrder" @cancelSuccess="cancelSuccess"></cancel-order>
    <!-- 编辑订单弹框组件 -->
    <edit-order ref="editOrder" :orderData="rowData" v-model="editDialogVisible" @editSave="editSave" @editClose="editClose"></edit-order>
    <!-- 导出订单弹框组件 -->
    <export-componet
      ref="exportComponet"
      :cityOptions="orderOptions"
      :idsLength="multipleSelection.length"
      :exportVisible="exportVisible"
      :exportData="exportData"
      @export-close="exportClose"
      @export-fn="exportFn"
    ></export-componet>

    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
    <!-- 打印 二次确认弹窗 -->
    <el-dialog
      :title="$lang('提示')"
      :width="'400px'"
      :visible.sync="dialogShow"
    >
      <main class="print_main">
        <p>{{ $lang('请选择面单是否显示运费信息') }}</p>
        <p>{{ $lang('结算方式为') }}"PP_CASH"、"PP_PM"{{ $lang('的订单打印后，面单上不显示运费信息') }}</p>
        <div class="main_radio">
          <el-radio class="radio" v-model="display" label="1">{{ $lang('显示') }}</el-radio>
          <el-radio v-model="display" label="0">{{ $lang('不显示') }}</el-radio>
        </div>
      </main>
      <footer slot="footer" class="print_footer">
        <el-button class="save_btn" :loading="saveLoading" @click="surePrintClick()">{{ $lang('保存') }}</el-button>
      </footer>
    </el-dialog>
  </div>
</template>
<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import { orderList, asyExportOrder, orderrDelete, orderTotalGroup, detailOrder, orderUpdate, printOrders, printOrderUrl, UserDetail, orderBatchDelete } from '@api/module/customer'
import bullet from '@components/base/BaseBullet.vue'
import cancelOrder from './components/CancelOrder.vue'
import mergeOrder from './components/MergeOrder.vue'
import editOrder from './components/EditOrder.vue'
import exportComponet from '@components/base/BaseExport.vue'
import { commonFun } from '@utils/common'
import { orderOptions, RESPONSE_SUCCESS } from '@constants'
import Print from './components/print/index.vue'
import { mapActions } from 'vuex'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'
import BaseInputTagNew from '../../components/base/BaseInputTagNew.vue'

import dayjs from 'dayjs'
export default {
  name: 'Order',
  mixins: [mixin],
  components: {
    JmsTableScroll,
    bullet,
    cancelOrder,
    editOrder,
    exportComponet,
    mergeOrder,
    Print,
    ExportDownloadDialog,
    BaseInputTagNew
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const space = 90 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const noewDate = dayjs(new Date().getTime()).format('YYYY-MM-DD')
          const maxTime = new Date(noewDate + ' 23:59:59').getTime()
          return time.getTime() < minTime || time.getTime() > maxTime
        }
      },
      COM_HTTP: {
        reqList: orderList,
        // reqExcel: regularOutputExcel,
        reqExcel: asyExportOrder,
        reqDel: orderrDelete,
        reqDetail: detailOrder,
        reqUpdate: orderUpdate
      },
      dialogShow: false,
      display: '',
      isShowFirst: false,
      searchParam: {
        date: commonFun.GetTodayDate(),
        startdate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        enddate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        ids: [], // 订单号
        receiverMobilePhone: '', // 手机号
        tabTypeCode: 'wait_print', // 页签（all，wait_pick，already_pick，already_cancle）
        waybillIds: [],
        customerOrderIds: []
      },
      menuItems: [], // tab菜单
      activeIndex: '1', // tab 选中
      multipleSelection: [], // 多选或全选数据
      disabled: true, // 禁止点击状态
      exportVisible: false, // 导出弹框显示
      excelParams: {}, // 导出日期条件
      exportStatus: 'wait_print', // 默认状态
      exportType: 1, // 1：订单； 2：运单
      exportData: {},
      orderOptions: [],
      selectId: '', // 当前选中的id
      mergeLoading: false, // 合并loading
      printLoading: false, // 打印按钮loading
      exportLoading: false, // 导出loading
      printTableVisible: false, // 子订单打印
      isShowMerge: false, // 合并
      mergeList: [], // 合并数据
      printOptions: {
        btnTitle: this.$lang('面单打印'),
        btnType: 'primary',
        addClass: 'h40'
      },
      isCheckedAll: false,
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [50, 100, 200, 500, 1000]
      },
      tabActive: 1,
      isKeyUp: false,
      autoPrint: false,
      dialogExportDownVisible: false, // 下载中心
      moduleType: '我的订单-网页下单', // 我的订单
      saveLoading: false
    }
  },
  async created() {
    this.isSinleSelection = []
    this.getUserInfo()
    const key = this.$route.params.typeNum
    this.updateOutExcel(key)
    await this.orderTotalGroup(this.searchParam)
    if (key) {
      this.handleSelect(key)
    } else {
      this.searchFun()
    }
  },
  computed: {
    listOpt() {
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        rowKey: '$index',
        fixHeight: 90,
        menuWidth: 150,
        // menuWidth: 150,
        //  搜索框和表格列及其字段
        column: [
          {
            label: this.$lang('订单编号'),
            prop: 'id'
          },
          {
            label: this.$lang('运单编号'),
            prop: 'waybillId',
            slot: true,
            width: 150
          },
          {
            label: this.$lang('状态'),
            prop: 'orderStatusName',
            slot: true
          },
          {
            label: this.$lang('打印次数'),
            prop: 'printsNumber'
          },
          {
            label: this.$lang('客户订单号'),
            prop: 'customerOrderId',
            width: 150
          },
          {
            label: this.$lang('COD金额'),
            prop: 'codMoney',
            width: 150
          },
          {
            label: this.$lang('COD手续费'),
            prop: 'codFee',
            width: 150
          },
          {
            label: this.$lang('寄件方'),
            prop: 'senderName',
            formatter: (row, value, label, column) => {
              return `${row.senderName},+855 ${row.senderMobilePhone},${row.senderProvinceName},${row.senderCityName},${row.senderAreaName},${row.senderDetailedAddress}`
            },
            width: 400
          },
          {
            label: this.$lang('寄件地址'),
            prop: 'senderDetailedAddress',
            width: 150
          },
          // {
          //   label: this.$lang('寄件地址2'),
          //   prop: 'senderAlternateAddress',
          //   width: 150
          // },
          {
            label: this.$lang('收件方'),
            prop: 'receiverName',
            formatter: (row, value, label, column) => {
              return `${row.receiverName},+855 ${row.receiverMobilePhone},${row.receiverProvinceName},${row.receiverCityName},${row.receiverAreaName},${row.receiverDetailedAddress}`
            },
            width: 400
          },
          {
            label: this.$lang('收件地址'),
            prop: 'receiverDetailedAddress',
            width: 150
          },
          // {
          //   label: this.$lang('收件地址2'),
          //   prop: 'receiverAlternateAddress',
          //   width: 150
          // },
          {
            label: this.$lang('物品类型'),
            prop: 'goodsTypeName'
          },
          {
            label: this.$lang('物品名称'),
            prop: 'goodsName'
          },
          {
            label: this.$lang('物品件数'),
            prop: 'packageNumber'
          },
          // {
          //   label: this.$lang('净重'),
          //   prop: 'netWeight'
          // },
          {
            label: this.$lang('包裹重'),
            prop: 'packageTotalWeight'
          },
          {
            label: this.$lang('物品价值'),
            prop: 'declaredValue'
          },
          {
            label: this.$lang('保价费'),
            prop: 'insuredValue'
          },
          {
            label: this.$lang('结算方式'),
            prop: 'paymentModeName'
          },
          {
            label: this.$lang('参考运费'),
            prop: 'standardValue',
            show: this.userInfo.freightStatus === 1
          },
          {
            label: this.$lang('订单来源'),
            prop: 'orderSourceName',
            width: 200
          },
          //   {
          //     label: '隐私面单',
          //     prop: 'isPrivacy',
          //     formatter(row) {
          //       return row.isPrivacy === 0 ? '否' : '是'
          //     },
          //   },
          {
            label: this.$lang('备注'),
            prop: 'remarks',
            width: 200
          },
          {
            label: this.$lang('下单账号'),
            prop: 'orderAccount',
            width: 150
          },
          {
            label: this.$lang('下单时间'),
            prop: 'inputTime',
            width: 150,
            show: this.exportStatus === 'all' || this.exportStatus === 'wait_pick'
          },
          {
            label: this.$lang('打印时间'),
            prop: 'printTime',
            width: 200
          },
          {
            label: this.$lang('取消时间'),
            prop: 'cancelTime',
            width: 150,
            show: this.exportStatus === 'already_cancle'
          },
          {
            label: this.$lang('取件时间'),
            prop: 'pickTime',
            width: 150,
            show: this.exportStatus === 'already_pick'
          },
          // {
          //   label: this.$lang('燃油附加费'),
          //   prop: 'fuelCost',
          //   show: this.userInfo.freightStatus === 1,
          //   width: 100
          // },
          // {
          //   label: this.$lang('增值税'),
          //   show: this.userInfo.freightStatus === 1,
          //   prop: 'fuelVat'
          // },
          {
            label: this.$lang('总运费'),
            show: this.userInfo.freightStatus === 1,
            prop: 'totalFreight'
          }
        ]
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    }
  },
  watch: {
    tableList: {
      handler(newVal, oldVal) {
        if (this.isKeyUp && this.exportStatus === 'wait_print' && this.tableList.length === 1 && this.autoPrint) {
          this.autoPrint = false
          this.multipleSelection = this.tableList
          this.$nextTick(() => {
            this.$refs.table.$refs.table.toggleRowSelection(this.tableList[0], true)
            this.$refs.printOrder && this.$refs.printOrder.openMenu()
          })
        }
      }
    },
    deep: true
  },
  methods: {
    ...mapActions(['LOGIN_OUT', 'SET_USER', 'UPDATE_PRINT_STOCK']),
    orderStatusClass(name) {
      if (name === this.$lang('待打印') || name === this.$lang('已打印')) {
        return 'oragin'
      } else if (name === this.$lang('已取件')) {
        return 'green'
      } else {
        return ''
      }
    },
    surePrintClick() {
      this.$nextTick(() => {
        this.$refs['printOrder'].toPrint('previewBig')
      })
    },
    printClick() {
      const payMethod = this.multipleSelection.some(item => ['PP_PM', 'PP_CASH'].includes(item.paymentModeCode))
      console.log('🚀 ~ file: Order.vue:502 ~ printClick ~ payMethod:', payMethod)
      if (payMethod) {
        this.dialogShow = true
        return
      }
      this.$nextTick(() => {
        this.$refs['printOrder'].toPrint('previewBig')
      })
    },
    /**
     * @description 复制
     */
    handleCopy(data) {
      const value = data.row.waybillId
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('运单号复制成功'),
        type: 'success'
      })
      oInput.remove()
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },

    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    toKeyUp() {
      if (this.isKeyUp) {
        // 回车搜索后首次输入清空输入框
        this.searchParam.customerOrderIds = []
        this.isKeyUp = false
      }
      return true
    },
    async payCode(e) {
      this.isKeyUp = true
      this.autoPrint = true
      this.searchFun(1)
      this.orderTotalGroup(this.searchParam)
    },
    // 获取打印数据
    async getPrintData(type, language, printType) {
      console.log(printType)
      if (this.isCheckedAll && this.multipleSelection.length !== this.tableList.length) {
        this.$nextTick(() => {
          this.$message.warning(this.$lang('请在页面加载完成后打印'))
        })
        return []
      }
      const obj = this.multipleSelection.find(item => item.paymentModeName === '到付现结' && (!item.standardValue || item.standardValue === 0 || item.standardValue === '0'))
      if (obj) {
        this.$nextTick(() => {
          this.$message.warning(this.$lang('存在到付快件未维护费用，请联系网点维护'))
          this.multipleSelection = []
          this.isCheckedAll = false
          this.searchChange()
        })
        return []
      }
      for (let i = 0; i < this.multipleSelection.length; i++) {
        const item = this.multipleSelection[i]
        const canPrint = this.$hasPower('orderPrint', item)
        if (!canPrint) {
          this.$message.warning(this.$lang('无打印主账号订单的权限'))
          return
        }
      }
      const newArr = this.multipleSelection.map((item, index, selection) => item.id)
      // const params = { ids: newArr, printType: type, isVip: true, language, type: printType.includes('Big') ? 2 : 1 } // 添加language
      // 2023-0327 修改为默认的模板直接预览
      this.saveLoading = true
      const params = { ids: newArr, printType: 1, isVip: true, language, type: 1, showCost: this.display }
      this.printLoading = true
      const res = printType.includes('print') ? await printOrders(params) : await printOrderUrl(params)
      this.saveLoading = false
      if (res === 'error') throw res
      if (res) {
        this.dialogShow = false
        // if (res && res.code === 1) {
        if (printType.includes('print')) {
          this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        }
        // settlementName 到付现结 freight
        this.isCheckedAll = false
        setTimeout(() => {
          this.searchChange()
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return res
      } else {
        // this.$message.error(this.$lang('打印失败'))
        if (printType.includes('print')) {
          this.$message.error(this.$lang('打印失败'))
        } else {
          this.$message.error(this.$lang(res.msg))
        }
        return null
      }
    },
    // 更新面单库存(获取用户信息)
    async getUserInfo() {
      const { code, data, msg } = await UserDetail({ id: this.userInfo.id })
      if (code === RESPONSE_SUCCESS) {
        this.SET_USER({ ...this.userInfo, ...data }) // 更新vuex的用户数据
      } else {
        this.$message.error(msg)
      }
    },
    // 删除订单
    async batchDelOrder() {
      const ids = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusName === this.$lang('已取消')) {
          ids.push(item.id)
        }
      })
      if (ids.length <= 0) {
        this.$message.warning(this.$lang('没有可取消的订单'))
        return
      }
      this.$confirm(
        `
      <div class="comfirm-wrap">
        <i class="el-icon-warning"></i>
        <h3 class="comfirm-hd">${this.$lang('删除订单')}</h3>
      </div>
      <p class="comfirm-tit">${this.$lang('你确定要删除已选中的订单吗？')}</p>
      `,
        '',
        {
          confirmButtonText: this.$lang('确定'),
          cancelButtonText: this.$lang('取消'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          customClass: 'comfirm-box'
        }
      )
        .then(async () => {
          this.loading = true
          const { code, msg } = await orderBatchDelete(ids)
          this.loading = false
          if (code === RESPONSE_SUCCESS) {
            this.$message.success(this.$lang('删除成功'))
            this.searchChange()
          } else {
            this.$message.error(this.$lang(msg))
          }
        })
        .catch(_ => {})
    },
    // 取消订单
    batchCancelOrder() {
      const ids = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        const item = this.multipleSelection[i]
        const canCancel = this.$hasPower('orderCancel', item)
        if (!canCancel) {
          this.$message.warning(this.$lang('无取消主账号订单的权限'))
          return
        }
      }
      this.multipleSelection.forEach(item => {
        if (this.orderStatusClass(item.orderStatusName) === 'oragin') {
          ids.push(item.id)
        }
      })
      if (ids.length <= 0) {
        this.$message.warning(this.$lang('没有可取消的订单'))
        return
      }
      this.selectId = ids.join(',')
      this.$refs.cancelOrder.dialogTableVisible = true
    },
    // 合单
    mergeOrder() {
      const arr1 = []
      const arr2 = []
      const selection = this.multipleSelection.filter(item => {
        if (item.orderStatusName !== this.$lang('待打印')) arr1.push(item)
        if (item.packageTotalWeight > 30) arr2.push(item)
        return item.orderStatusName === this.$lang('待打印') && item.packageTotalWeight <= 30
      })
      if (arr2.length > 0) {
        this.$message.warning(this.$lang('单票寄件重量不能大于30kg，无法合单，请重新选择！'))
        return
      }
      if (selection.length < 2) {
        if (arr1.length > 0) {
          this.$message.warning(this.$lang('只有待打印订单才可以合单！'))
          return
        }
      }
      const map = {}
      const keys = [
        'senderName',
        'senderMobilePhone',
        'senderProvinceName',
        'senderCityName',
        'senderAreaName',
        'senderDetailedAddress',
        'receiverName',
        'receiverMobilePhone',
        'receiverProvinceName',
        'receiverCityName',
        'receiverAreaName',
        'receiverDetailedAddress'
      ]
      const keysFn = item => keys.map(key => item[key].toString()).join('')
      selection.forEach(item => {
        const key = keysFn(item)
        if (!map[key]) {
          map[key] = [item]
        } else {
          map[key].push(item)
        }
      })
      for (const key in map) {
        if (map[key].length > 1) {
          this.mergeList.push(map[key])
        }
      }
      if (this.mergeList.length < 1) return this.$message.warning(this.$lang('未查询到可以合并的订单'))
      this.isShowMerge = true
    },
    // 关闭合单弹窗
    closeMerge(isReload) {
      this.isShowMerge = false
      this.mergeList = []
      if (isReload) {
        this.searchChange()
      }
    },
    // 面单打印
    openMenu(e, sub) {
      this.$rightMenu.open({
        target: e,
        menuList: [
          {
            val: this.$lang('两联面单'),
            abled: true,
            value: 2
          },
          {
            val: this.$lang('一联面单'),
            abled: true,
            value: 1
          }
        ],
        posobj: {
          left: e.clientX,
          top: e.clientY
        },
        callback: ({ value }) => {
          this.print(value)
          this.$rightMenu.close()
        }
      })
    },
    // 选择日期
    selectDate() {
      if (!this.searchParam.date) {
        return
      }
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startdate = start
      this.searchParam.enddate = end
    },
    // 查询
    async searchChange(params) {
      const { startdate, enddate } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTime = new Date(startdate).getTime()
      const endTime = new Date(enddate).getTime()
      if (endTime - startTime > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        return
      }
      this.searchParam.tabTypeCode = this.menuItems.length > 0 ? this.menuItems[this.activeIndex].orderStatusCode : ''
      // 处理订单编号
      const { ids, waybillIds } = this.searchParam
      if (ids && ids.length !== 0) {
        if (ids.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条订单'))
        }
        const p_billNo = ids.join(',')
        if (isNaN(p_billNo.replace(/,/g, ''))) {
          return this.$message.error(this.$lang('订单编号为全数字'))
        }
      }
      this.searchParam.customerOrderIds = this.searchParam.customerOrderIds.length > 0 && !this.searchParam.customerOrderIds[0] ? [] : this.searchParam.customerOrderIds
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }
      // 列表查询
      this.searchFun(1)
      // 列表总数查询
      this.orderTotalGroup(this.searchParam)
      this.multipleSelection = []
    },
    getParams() {
      const { tabTypeCode, ids } = this.searchParam
      const newIds = ids && ids.length >= 1 && ids[0] === '' ? [] : ids
      const searchParam = Object.assign({}, this.searchParam)
      searchParam.ids = newIds
      searchParam.tabTypeCode === '0' ? '' : tabTypeCode
      searchParam.isVip = true
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'tabTypeCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip']
      Object.keys(searchParam).forEach(item => {
        if (!arr.includes(item)) {
          if (searchParam[item] instanceof Array && searchParam[item][0]) {
            delete searchParam.startdate
            delete searchParam.enddate
          } else if (typeof searchParam[item] === 'string' && searchParam[item]) {
            delete searchParam.startdate
            delete searchParam.enddate
          }
        }
      })
      return searchParam
    },
    handleSelect(key) {
      const menuItems = this.menuItems
      this.searchParam.tabTypeCode = menuItems[key].orderStatusCode
      this.exportStatus = menuItems[key].orderStatusCode
      this.activeIndex = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.isCheckedAll = false
      // 重置表格滚动条置顶
      this.$refs.table.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      this.searchFun()
      // 清空选中数据
      this.multipleSelection = []
      this.autoPrint = false
      // 列表总数查询
      this.orderTotalGroup(this.searchParam)
      this.$nextTick(() => {
        this.$refs.table.$refs.table.doLayout()
      })
    },
    cancelFn(row) {
      this.selectId = row.id
      this.$refs.cancelOrder.dialogTableVisible = true
    },
    // 取消成功
    cancelSuccess() {
      this.multipleSelection = []
      this.isCheckedAll = false
      setTimeout(() => {
        this.orderTotalGroup(this.searchParam)
        this.searchFun()
      }, 1000)
    },
    // 删除成功回调
    afterDelSuccess() {
      this.cancelSuccess()
    },
    // 打开导出弹框
    async exportOpen() {
      // 处理订单编号
      const { ids, waybillIds } = this.searchParam
      if (ids && ids.length !== 0) {
        if (ids.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条订单'))
        }
        const p_billNo = ids.join(',')
        if (isNaN(p_billNo.replace(/,/g, ''))) {
          return this.$message.error(this.$lang('订单编号为全数字'))
        }
      }
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }

      if (this.multipleSelection.length <= 0) {
        this.exportLoading = true
        await this.orderTotalGroup(this.searchParam)
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.menuItems[this.activeIndex].total || 0
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      this.orderOptions = [...orderOptions]
      /**
       * @description 如果设置了 不显示参考运费 删除参考运费
       */
      if (this.userInfo.freightStatus === 0) {
        const chooseIndex = this.orderOptions.filter(item => item.name !== '参考运费' && item.name !== '燃油附加费' && item.name !== '增值税' && item.name !== '总运费')
        this.orderOptions = chooseIndex
      }

      this.updateOutExcel(this.currentKey)
      this.exportVisible = true
      const exportData = {
        // startDate: this.searchParam.startdate,
        // endDate: this.searchParam.enddate,
        exportStatus: this.exportStatus,
        exportType: this.exportType // 1：订单； 2：运单
      }
      this.exportData = exportData
    },
    // 关闭导出弹框
    exportClose(val) {
      this.exportVisible = val
    },
    // 导出-获取参数
    getParamForOutExcel() {
      const sort = []
      const columnNames = []
      let ids = []
      const len = (this.multipleSelection && this.multipleSelection.length) || 0
      if (len) ids = this.multipleSelection.map(item => item.id)
      // 处理导出表格的属性字段
      this.columnList.forEach(item => {
        sort.push(item.key)
        columnNames.push(item.name)
      })
      let params = { sort, columnNames, orderStatusCode: this.exportStatus, tabTypeCode: this.exportStatus, isVip: true }
      if (len) params = { ...params, ids }
      else {
        params = { ...params, ...this.searchParam }
      }
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'tabTypeCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip']
      Object.keys(params).forEach(item => {
        if (!arr.includes(item)) {
          if (params[item] instanceof Array && params[item][0]) {
            delete params.startdate
            delete params.enddate
          } else if (typeof params[item] === 'string' && params[item]) {
            delete params.startdate
            delete params.enddate
          }
        }
      })
      return params
    },
    // 导出数据
    async exportFn(bool, data, dataParams) {
      this.exportVisible = bool
      this.columnList = data
      this.excelParams = dataParams
      //   await this.outExcel()
      //   改为异步导出
      await this.asyExportOrder()
    },
    async asyExportOrder() {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请到下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 更新导出参数配置
    updateOutExcel(key = 0) {
      // cityOptions
      const inputTime = {
        key: 'inputTime',
        name: this.$lang('下单时间')
      }
      const pickTime = {
        key: 'pickTime',
        name: this.$lang('取件时间')
      }
      const cancelTime = {
        key: 'cancelTime',
        name: this.$lang('取消时间')
      }
      //   const printTime = {
      // key: 'printTime',
      // name: '打印时间',
      //   }
      this.orderOptions.push(inputTime, pickTime, cancelTime)
    },
    // 获取tabs
    async orderTotalGroup(reqData) {
      // 运单状态数据统计
      const { code, data } = await orderTotalGroup(this.getParams())
      if (code === RESPONSE_SUCCESS) this.menuItems = data
    },
    openFile(blob, fileName) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.target = '_blank'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
    },
    dataURLtoBlob(data) {
      const bstr = atob(data)
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: 'application/pdf' })
    },
    // 查看
    rowView(row) {
      this.selectId = row.id
      this.viewDialogVisible = true
      // 获取查看详情
      this.viewFun(row)
    },
    // close:关闭；delWaybill删除运单  ； cancelOrder:取消订单； ediOrder:编辑订单 delOrder:删除订单；
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
      switch (val.type) {
        case 'cancelOrder':
          this.$refs.cancelOrder.dialogTableVisible = true
          break
        case 'ediOrder':
          this.editDialogVisible = true
          break
        case 'delOrder':
          const item = {
            orderId: val.rowData.id
          }
          this.rowDel(item)
          break
      }
    },
    // 编辑取消
    editClose() {
      this.handleClose()
    },
    // 编辑保存
    editSave(data) {
      this.$refs['editOrder'].$refs['orderForm'].validate(async valid => {
        if (valid) {
          const formData = {
            id: data.id, // 订单编号,
            receiverName: data.receiverName, // 收件人姓名,
            receiverMobilePhone: data.receiverMobilePhone, // 收件人手机号,
            receiverProvinceId: data.receiverProvinceId, // 收件省份id,
            receiverProvinceName: data.receiverProvinceName, // 收件省份名称,
            receiverCityId: data.receiverCityId, // 收件城市id,
            receiverCityName: data.receiverCityName, // 收件城市名称,
            receiverAreaId: data.receiverAreaId, // 收件区域id,
            customerCode: data.customerCode, // 客户code,
            senderName: data.senderName, // 寄件人姓名,
            senderMobilePhone: data.senderMobilePhone, // 寄件人手机号,
            senderProvinceId: data.senderProvinceId, // 寄件省份id,
            senderProvinceName: data.senderProvinceName, // 寄件省份名称,
            senderCityId: data.senderCityId, // 寄件城市id,
            senderCityName: data.senderCityName, // 寄件城市名称,
            paymentModeCode: data.paymentModeCode, // 结算方式code（支付方式）,
            senderDetailedAddress: data.senderDetailedAddress, // 寄件详细地址,
            senderAreaId: data.senderAreaId, // 寄件区域Id,
            declaredValue: data.declaredValue, // 保价金额,
            receiverDetailedAddress: data.receiverDetailedAddress, // 收件详细地址,
            goodsTypeCode: data.goodsTypeCode, // 物品类型code,
            insured: data.insured, // 是否需要保价费
            insuredValue: data.insuredValue, // 保价费,
            standardValue: data.standardValue, // 标准运费,
            receiverAreaName: data.receiverAreaName, // 收件区域名称,
            senderAreaName: data.senderAreaName, // 寄件区域名称,
            customerId: data.customerId, // 客户id(会员id),
            customerName: data.customerName, // 客户名称,
            packageTotalWeight: data.packageTotalWeight, // 包裹重,
            packageNumber: 1,
            //  data.packageNumber, // 物品件数,
            goodsName: data.goodsName, // 物品名称,
            codMoney: data.codMoney, // 代收货款金额,
            expressTypeCode: data.expressTypeCode, // 快件类型code（产品类型）,
            boxStandardCode: data.boxStandardCode, // 箱子规格code,
            boxStandardName: data.boxStandardName, // 箱子规格名称,
            boxNumber: data.boxNumber, // 箱子数量,
            boxPrice: data.boxPrice, // 箱子单价,
            boxStandardId: data.boxStandardId, // 箱子规格id,
            remarks: data.remarks, // 备注,
            receivableFreight: data.receivableFreight, // 参考运费,
            from: 8, // 8 来源 大客户,
            settlementWeight: data.settlementWeight, // 结算重量
            packageChargeWeight: data.packageTotalWeight // 结算重量
          }
          this.$refs['editOrder'].keyBtn = true
          // 编辑保存
          this.submitForm('reqUpdate', formData)
        } else {
          return false
        }
      })
    },
    // 表单关闭（关闭弹窗）
    beforehandleClose() {
      this.$refs['editOrder'].keyBtn = false
    },
    // 重置编辑表单
    clearFormItem() {
      this.$refs['editOrder'].$refs['orderForm'].resetFields()
    },
    printDialogClode() {
      this.printTableVisible = false
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = {
        ids: [],
        date: commonFun.GetTodayDate(),
        startdate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        enddate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        waybillIds: [],
        customerOrderIds: []
      }
      this.$refs.BaseInputTag1.clearFn()
      this.$refs.BaseInputTag2.clearFn()
    },
    // 全选
    handleSelectAll1(val) {
      console.log('全选 ======>', val)
      this.multipleSelection = val
      this.originSelectionAll = [...val]
      if (val.length) {
        this.isCheckedAll = true
      } else {
        this.isCheckedAll = false
      }
    },
    // 单个选中
    handleSelectionChange(val, currentRow) {
      // 检测当前行的选中状态
      const isChecked = val.some(item => item.id === currentRow.id)
      if (this.isCheckedAll) {
        if (!isChecked) {
          this.isSinleSelection = [...(this.isSinleSelection || []), currentRow.id]
        } else {
          this.isSinleSelection = this.isSinleSelection.filter(item => item !== currentRow.id)
        }
        this.multipleSelection = this.originSelectionAll.filter(item => !this.isSinleSelection.includes(item.id))
      } else {
        this.multipleSelection = val
      }
    },
    changeTab(index) {
      this.tabActive = index
      this.handleSelect(index)
    },
    /**
     * 去快件查询
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    },
    handleCompositionEnd(e) {
      console.log(e)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}
.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}
input {
  font-size: 12px !important;
}
.order {
  .order-top {
    padding: 16px 24px;
    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
  }
  .order-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }
  .search-btns {
    margin-bottom: 10px;
  }
  .tabs-nav {
    // margin: 5px 0 9px;
    .tabs-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      user-select: none;
      padding: 12px 20px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      &:first-of-type {
        margin-left: 0px;
      }
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
    .tabs-nav-item-count {
      display: inline-block;
      width: 35px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
.print_main{
  p:nth-child(1){
    font-weight: 600;
    font-size: 16px;
    color: #000;
  }
  p:nth-child(2){
    line-height: 17px;

  }
  .main_radio{
    display: flex;
    flex-direction: column;
    .radio{
      margin: 20px 0 30px;
    }
  }
}
.print_footer{
  display: flex;
  justify-content: center;
  .save_btn{
    width: 140px;
    height: 40px;
    font-size: 18px;
    color: #fff;
    background-color: #e60012;
    text-align: center;
    border-radius: 5px;
    margin: 20px 0;
    cursor: pointer;
  }
}
::v-deep{
  .el-dialog__header{
    padding: 30px 20px;
  }
  .el-dialog__headerbtn{
    top: 28px !important;
  }
  .el-dialog__body{
    padding: 20px 20px 50px !important;
    border-bottom: 1px solid #eee;
  }
}
</style>
<style lang="scss">
.order .order-top .el-input__inner {
  margin-bottom: 10px;
}

</style>
